const home = {
  name: 'Home',
  id: 'home',
  type: 'home',
  title: {
    en: '2030 Vision<br/>for Industrie 4.0',
    de: 'Leitbild 2030<br/>für Industrie 4.0',
  },
  subtitle: {
    en: 'Shaping Digital Ecosystems Globally',
    de: 'Digitale Ökosysteme global gestalten',
  },
  information: {
    title: {
      en: 'The 2030 vision as a holistic approach to shaping digital ecosystems',
      de: 'Das Leitbild 2030 als ganzheitlicher Ansatz zur Gestaltung digitaler Ökosysteme',
    },
    text: {
      en:
        'How can economic strength and societal values find their place in the digital era? Plattform Industrie 4.0’s 2030 Vision formulates a holistic approach to the shaping of digital ecosystems and reorientates the development of Industrie 4.0. At the heart of the design of digital ecosystems are the following strategic fields of action: Autonomy, Interoperability and Sustainability.',
      de:
        'Wie können wirtschaftliche Stärke und gesellschaftliche Werte ins digitale Zeitalter übersetzen werden? Das Leitbild 2030 der Plattform Industrie 4.0 formuliert einen ganzheitlichen Ansatz zur Gestaltung digitaler Ökosysteme und richtet die Entwicklung von Industrie 4.0 neu aus.  Zentral für die Gestaltung digitaler Ökosysteme sind dabei die strategischen Handlungsfelder: Souveränität, Interoperabilität und Nachhaltigkeit.',
    },
    links: {
      en: [
        {
          text: 'Learn more in the overview paper of the 2030 Vision',
          url:
            'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/Vision-2030-for-Industrie-4.0.html',
        },
      ],
      de: [
        {
          text: 'Mehr dazu im Leitbild Überblickspapier',
          url:
            'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/Leitbild-2030-f%C3%BCr-Industrie-4.0.html',
        },
      ],
    },
  },
};

const souverenty = {
  name: 'Souverenty',
  id: 'souverenty',
  type: 'scene',
  title: {
    en: 'Autonomy',
    de: 'Souveränität',
  },
  subtitle: {
    en: 'Scope for action delivers competitiveness and control of personal data in digital business models',
    de: 'Freie Gestaltungsräume und Selbst bestimmung garantieren Wettbewerbsfähigkeit in digitalen Geschäftsmodellen.',
  },
  information: {
    title: {
      en: '',
      de: '',
    },
    text: {
      en:
        'Autonomy is the freedom to take independent decisions and to interact in conditions of fair competition – from a chosen business model to an individual’s decision to make a purchase. Autonomy requires an open digital infrastructure for everyone, data protection, IT and information security and technology-neutral research, development and innovation.',
      de:
        'Souveränität ist die Freiheit aller, unabhängige Entscheidungen zu treffen und im fairen Wettbewerb miteinander zu agieren. Von Unternehmen und MitarbeiterInnen bis hin zur Wissenschaft. Vom Geschäftsmodell bis zur Kaufentscheidung des Einzelnen. <br /> Souveränität erfordert eine offene digitale Infrastruktur für alle, Datenschutz, IT- und Informationssicherheit sowie technologieoffene Forschung, Entwicklung und Innovationen.',
    },

    links: {
      en: [
        {
          text: 'Learn more in the policy paper on Autonomy',
          url: '',
        },
      ],
      de: [
        {
          text: 'Mehr dazu im Positionspapier Souveränität',
          url: '',
        },
      ],
    },
  },
  imageSmall: require('./assets/scenes/souverenty-small.svg'),
  imageBig: require('./assets/scenes/souverenty-big.svg'),
  flag: 'right',
  pos: {
    x: 600,
    y: 30,
  },
  marks: [
    {
      handleNext: 'interoperability-digital-infrastructure',
      x: 76.3,
      y: 67.5,
      type: 'digital-infrastructure',
      title: {
        en: 'Digital<br/>infrastructure',
        de: 'Digitale<br/>Infrastruktur',
      },
      text: {
        en: `<p>The permanent dynamic configuration of value networks between different
        companies requires a powerful, autonomous infrastructure for digital industrial value
        creation. <b>This infrastructure must be equally accessible for all participants and
        available without restriction.</b> It defines access to the ecosystems of Industrie 4.0 and
        guarantees pluralistic action and market diversity.</p><p>As a strategic asset, a resilient
        infrastructure brings together all the overarching requirements and services needed
        for the cross-border and cross-sectoral collection, exchange, analysis and use of data.</p>`,
        de: `<p>Mit der permanenten dynamischen Konfiguration von Wertschöpfungsnetzwerken
        auch über Unternehmensgrenzen hinweg kommt einer leistungsstarken, souveränen
        Infrastruktur für digitale industrielle Wertschöpfung eine Schlüsselrolle zu. <b>Diese
        Infrastruktur muss für alle Teilnehmer gleichermaßen offen zugänglich sein und
        ohne Einschränkungen zur Verfügung stehen</b>. Sie definiert den Zugang zu den
        Ökosystemen der Industrie 4.0 und garantiert pluralistisches Agieren und die Vielfalt
        am Markt.</p><p>Als strategisches Asset bündelt eine resiliente Infrastruktur alle
        übergreifenden Anforderungen und Dienste, die zur grenz- und
        sektorenübergreifenden Erfassung, Austausch, Analyse und Anwendung von Daten
        benötigt werden.</p>`,
      },
    },
    {
      handleNext: 'interoperability-security',
      x: 140,
      y: 27,
      type: 'security',
      title: {
        en: 'Security',
        de: 'Sicherheit',
      },
      text: {
        en: `
        <p>Data protection, IT and information security are a firmly established principle in our
        industry and society. They are a basic precondition for Industrie 4.0 and for
        cooperation within digital ecosystems. In the face of all the challenges, they have
        established the <b>basis for the high level of global confidence in Industrie 4.0</b>.
        </p>
        <p>Companies, employees and private individuals will in future increasingly need to be
        able to rely on their data being protected, on the use of it being transparent, and on
        their being able to decide autonomously what use they permit, what use they do not
        permit, and when they wish to deploy their “right to be forgotten”.
        </p>`,
        de: `<p>Datenschutz, IT- und Informationssicherheit stellen einen fest etablierten
        industriellen und gesellschaftlichen Wert dar. Sie sind eine Grundvoraussetzung für
        Industrie 4.0 und die Kooperation innerhalb digitaler Ökosysteme. Bei allen damit
        verbundenen Herausforderungen haben sie die <b>Basis für das weltweit hohe
        Vertrauen in Industrie 4.0</b> geschaffen.</p><p>Unternehmen, Mitarbeiter und
        Einzelpersonen müssen sich auch in Zukunft mehr denn je darauf verlassen können,
        dass ihre Daten geschützt sind, deren Verwendung transparent ist und sie souverän
        entscheiden können, wofür sie deren Verwendung erlauben, wofür nicht und wann
        sie ihr „Recht auf Vergessenwerden“ in Anspruch nehmen.<p>`,
      },
    },
    {
      handleNext: 'interoperability-technologieentwicklung',
      x: 40,
      y: 8.5,
      type: 'technology',
      title: {
        en: 'Technology<br/>development',
        de: 'Technologie-<br/>entwicklung',
      },
      text: {
        en: `Autonomy in Industrie 4.0 requires technology-neutral research, development and
        innovation in the core areas of digital industrial value creation. In addition to <b>the
        leading role played by the developments in technology, it is also particularly
        important to implement data protection and security by design</b>, as well as
        sustainability and interoperability. Finally, dynamic integration into the applications
        and digital business models ensures that all participants in the ecosystem participate
        in and benefit from the advances in technology.`,
        de: `Souveränität bei Industrie 4.0 setzt technologieoffene Forschung, Entwicklung und
        Innovationen in den Kernbereichen der digitalen industriellen Wertschöpfung voraus.
        Neben <b>der technologischen Führungsrolle der Entwicklungen gilt es dabei
        insbesondere Datenschutz und Security „by design“ zu realisieren</b>, genauso wie
        Nachhaltigkeit und Interoperabilität. Die dynamische Integration in die Anwendung
        und digitalen Geschäftsmodelle gewährleistet schließlich, dass alle Teilnehmer des
        Ökosystems an den technologischen Entwicklungen partizipieren und profitieren. `,
      },
    },
  ],
  subscenes: [
    {
      name: 'Interoperability digital infrastructure',
      id: 'interoperability-digital-infrastructure',
      type: 'subscene',
      title: {
        en: 'Digital infrastructure',
        de: 'Digitale Infrastruktur',
      },
      subtitle: {
        en: '',
        de: '',
      },
      information: {
        title: {
          en: 'Digital infrastructure - equally accessible for all participants ',
          de: 'Digitale Infrastruktur - für alle Teilnehmer offen zugänglich',
        },
        text: {
          en:
            'Autonomous infrastructure becomes increasingly important for digital industrial value creation. Because value creation networks are reaching beyond company boundaries. Digital Infrastructure defines access to the ecosystems of Industrie 4.0 and guarantees pluralistic action and market diversity. As a strategic asset, a resilient infrastructure brings together all the overarching requirements and services needed for the cross-sectoral collection, exchange, analysis and use of data.',
          de:
            'Eine souveräne Infrastruktur für digitale industrielle Wertschöpfung wird immer wichtiger. Denn Wertschöpfungsnetzwerke reichen zunehmend auch über Unternehmensgrenzen hinweg.<br >Digitale Infrastruktur definiert den Zugang zu den Ökosystemen der Industrie 4.0 und garantiert pluralistisches Agieren und Vielfalt am Markt. Als strategisches Asset bündelt eine resiliente Infrastruktur alle übergreifenden Anforderungen und Dienste, die zur grenzübergreifenden Erfassung, Austausch und Anwendung von Daten nötig sind.',
        },
        links: {
          // en: [
          //   {
          //     text: 'A more agile and flexible innovation system',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/memorandum-research-council-market-success.html',
          //   },
          // ],
          // de: [],
        },
      },
      marks: [
        {
          isNewMarker: true,
          x: 58,
          y: 10,
          type: 'news',
          contentType: 'link',
          link: {
            en:
              'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/memorandum-research-council-market-success.html',

            de:
              'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/memorandum-research-council-market-success.html',
          },
          label: {
            en: 'Flexible<br/>innovation system',
            de: 'Flexible<br/>innovation system',
          },
        },
      ],
      pos: {
        x: 12,
        y: 48,
        zIndex: 2,
      },
      imageSmall: require('./assets/scenes/souverenity/INFRASTRUKTURE.svg'),
      imageBig: require('./assets/scenes/souverenity/INFRASTRUKTURE.svg'),
    },
    {
      name: 'Interoperability security',
      id: 'interoperability-security',
      type: 'subscene',
      title: {
        en: 'Security',
        de: 'Sicherheit',
      },
      subtitle: {
        en: '',
        de: '',
      },
      information: {
        title: {
          en: 'Security as basis for the high level of global confidence in Industrie 4.0. ',
          de: 'Sicherheit als Basis für das weltweit hohe Vertrauen in Industrie 4.0',
        },
        text: {
          en:
            'Data protection, IT and information security are a firmly established principle in our industry and society. They are a basic precondition for Industrie 4.0 and for cooperation within digital ecosystems. Companies, employees and private individuals need to be increasingly able to rely on their data being protected, on the use of it being transparent, and on their being able to decide autonomously what use they permit, and when they wish to deploy their “right to be forgotten”.',
          de:
            'Datenschutz, IT- und Informationssicherheit sind ein industrieller und gesellschaftlicher Wert. Sie sind eine Grundvoraussetzung für Industrie 4.0 und die Kooperation innerhalb digitaler Ökosysteme. Unternehmen, Mitarbeiter und Einzelpersonen müssen sich auch in Zukunft darauf verlassen können, dass ihre Daten geschützt sind, deren Verwendung transparent ist und sie entscheiden können, wofür sie deren Verwendung erlauben, und wann sie ihr „Recht auf Vergessenwerden“ in Anspruch nehmen.',
        },
        links: {
          en: [
            // {
            //   text: 'Security within PI4.0',
            //   url: 'https://www.plattform-i40.de/PI40/Navigation/EN/Industrie40/AreasofAction/Security/security.html',
            // },
            // {
            //   text: 'Securing Global Industrial Value Networks',
            //   url:
            //     'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/2018-conference-report-securing-global-industria-value-networks.html',
            // },
            // {
            //   text: 'Secure implementation of OPC UA',
            //   url:
            //     'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/secure-implementation-of-opc.html',
            // },
          ],
          de: [
            // {
            //   text: 'Sicherheit in der PI4.0',
            //   url:
            //     'https://www.plattform-i40.de/PI40/Navigation/DE/Industrie40/Handlungsfelder/Sicherheit/sicherheit.html',
            // },
            // {
            //   text: 'Künstliche Intelligenz in I4.0 Sicherheitsaspekten ',
            //   url:
            //     'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/KI-in-sicherheitsaspekten.html',
            // },
            // {
            //   text: 'Sichere unternehmensübergreifende Kommunikation',
            //   url:
            //     'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/sichere-kommunikation-opc-ua.html',
            // },
          ],
        },
      },
      marks: [
        {
          isNewMarker: true,
          x: 58,
          y: 70,
          type: 'theme',
          contentType: 'link',
          link: {
            de:
              'https://www.plattform-i40.de/PI40/Navigation/DE/Industrie40/Handlungsfelder/Sicherheit/sicherheit.html',
            en: 'https://www.plattform-i40.de/PI40/Navigation/EN/Industrie40/AreasofAction/Security/security.html',
          },
          label: {
            en: 'Security within PI4.0',
            de: 'Sicherheit in der PI4.0',
          },
        },
        {
          isNewMarker: true,
          x: 20,
          y: 0,
          type: 'publication',
          contentType: 'link',
          link: {
            de: 'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/KI-in-sicherheitsaspekten.html',
            en:
              'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/2018-conference-report-securing-global-industria-value-networks.html',
          },
          label: {
            en: 'Securing Global<br /> Industrial Value Networks',
            de: 'Künstliche Intelligenz<br /> in I4.0 Sicherheitsaspekten',
          },
        },
        {
          isNewMarker: true,
          x: 60,
          y: 30,
          type: 'publication',
          contentType: 'link',
          link: {
            de:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/sichere-kommunikation-opc-ua.html',
            en:
              'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/secure-implementation-of-opc.html',
          },
          label: {
            en: 'Secure implementation of OPC UA',
            de: 'Sichere unternehmensübergreifende<br /> Kommunikation',
          },
        },
      ],
      pos: {
        x: 70,
        y: 18,
        zIndex: 1,
      },
      imageSmall: require('./assets/scenes/souverenity/2_1_2_IFOK_WIM_SOUVERENITY_SAVETY_platform_for_svg_je.svg'),
      imageBig: require('./assets/scenes/souverenity/2_1_2_IFOK_WIM_SOUVERENITY_SAVETY_platform_for_svg_je.svg'),
    },
    {
      name: 'Interoperability technologieentwicklung',
      id: 'interoperability-technologieentwicklung',
      type: 'subscene',
      title: {
        en: 'Technology development',
        de: 'Technologieentwicklung',
      },
      subtitle: {
        en: '',
        de: '',
      },
      information: {
        title: {
          en: 'Technology development with data protection and security "by design"',
          de: 'Technologieentwicklung mit Datenschutz und Security „by design“ ',
        },
        text: {
          en:
            'Autonomy in Industrie 4.0 requires technology-neutral research, development and innovation in the core areas of digital industrial value creation. Dynamic integration into the applications and digital business models ensures that all participants in the ecosystem participate in and benefit from the advances in technology - through security by design, sustainability and interoperability.',
          de:
            'Souveränität bei Industrie 4.0 setzt technologieoffene Forschung, Entwicklung und Innovationen in den Kernbereichen der digitalen industriellen Wertschöpfung voraus. Die dynamische Integration in die Anwendung und digitalen Geschäftsmodelle gewährleistet, dass alle Teilnehmer des Ökosystems an den technologischen Entwicklungen partizipieren und profitieren – durch Sicherheit, Nachhaltigkeit und Interoperabilität.',
        },
        links: {
          en: [
            // {
            //   text: 'Research and Innovation within PI4.0',
            //   url:
            //     'https://www.plattform-i40.de/PI40/Navigation/EN/Industrie40/AreasofAction/ResearchAndInnovation/research-and-innovation.html',
            // },
            // {
            //   text: 'Technology and Application Scenarios',
            //   url:
            //     'https://www.plattform-i40.de/PI40/Navigation/EN/ThePlatform/PlatformWorkinggroupss/Technology-Application-Scenarios/technology-application-scenarios.html',
            // },
            // {
            //   text: 'Technology Scenario: Artificial Intelligence in I4.0',
            //   url: 'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/AI-in-Industrie4.0.html',
            // },
          ],
          de: [
            // {
            //   text: 'Forschung und Innovation in der PI4.0',
            //   url:
            //     'https://www.plattform-i40.de/PI40/Navigation/DE/Industrie40/Handlungsfelder/ForschungInnovation/forschung-und-innovation.html',
            // },
            // {
            //   text: 'Technologie- und Anwendungsszenarien',
            //   url: 'https://www.plattform-i40.de/PI40/Redaktion/DE/Standardartikel/arbeitsgruppe-02.html',
            // },
            // {
            //   text: 'Technologieszenario: Künstliche Intelligenz in der I4.0',
            //   url: 'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/KI-industrie-40.html',
            // },
            // {
            //   text: 'Anwendungsszenario trifft Praxis',
            //   url:
            //     'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/anwendungsszenari0-trifft-praxis.html',
            // },
          ],
        },
      },
      marks: [
        {
          isNewMarker: true,
          x: 58,
          y: 70,
          type: 'theme',
          contentType: 'link',
          link: {
            en:
              'https://www.plattform-i40.de/PI40/Navigation/EN/Industrie40/AreasofAction/NormsAndStandards/norms-and-standards.html',
            de:
              'https://www.plattform-i40.de/PI40/Navigation/DE/Industrie40/Handlungsfelder/ForschungInnovation/forschung-und-innovation.html',
          },
          label: {
            en: 'Research and Innovation<br /> within PI4.0',
            de: 'Forschung und<br />Innovation in der PI4.0',
          },
        },
        {
          isNewMarker: true,
          x: 20,
          y: 0,
          type: 'groups',
          contentType: 'link',
          link: {
            de: 'https://www.plattform-i40.de/PI40/Redaktion/DE/Standardartikel/arbeitsgruppe-02.html',
            en:
              'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/blockchain-and-the-law-industrie4.0.html',
          },
          label: {
            de: 'Technologie- und Anwendungsszenarien',
            en: 'Technology and Application Scenarios',
          },
        },
        {
          isNewMarker: true,
          x: 60,
          y: 30,
          type: 'publication',
          contentType: 'link',
          link: {
            de: 'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/KI-industrie-40.html',
            en:
              'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/2019-administration-shell-flyer.html',
          },
          label: {
            dde: 'Technologieszenario: Künstliche <br />Intelligenz in der I4.0',
            en: 'Technology Scenario: <brr />Artificial Intelligence in I4.0',
          },
        },
        {
          isNewMarker: true,
          x: 90,
          y: 54,
          type: 'publication',
          contentType: 'link',
          link: {
            en:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/anwendungsszenari0-trifft-praxis.html',
            de:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/anwendungsszenari0-trifft-praxis.html',
          },
          label: {
            en: 'Anwendungsszenario trifft Praxis ',
            de: 'Anwendungsszenario trifft Praxis ',
          },
        },
      ],
      pos: {
        x: 12,
        y: 16,
        zIndex: 0,
      },
      imageSmall: require('./assets/scenes/souverenity/2_1_3_IFOK_WIM_SOUVERENITY_TECH_platform_for_svg_je.svg'),
      imageBig: require('./assets/scenes/souverenity/2_1_3_IFOK_WIM_SOUVERENITY_TECH_platform_for_svg_je.svg'),
    },
  ],
};

const interoperability = {
  name: 'Interoperability',
  id: 'interoperability',
  type: 'scene',
  title: {
    en: 'Interoperability',
    de: 'Interoperabilität',
  },
  subtitle: {
    en: 'Cooperation and open ecosystems permit plurality and flexibility',
    de: 'Kooperation und offene Ökosysteme  ermöglichen Pluralität und Flexibilität.',
  },
  information: {
    title: {
      en: '',
      de: '',
    },
    text: {
      en:
        'The interoperability of all stakeholders is necessary for the shaping of complex, decentralized ecosystems. A high level of interoperability – to which all the partners commit and contribute equally – is required to ensure networking across companies and sectors. Standards and integration are needed for this, as are a uniform regulatory framework, decentralised systems and artificial intelligence.',
      de:
        'Zur Gestaltung von komplexen, dezentral organisierten Ökosystemen ist die Interoperabilität, d.h. die nahtlose Zusammenarbeit, aller Akteure erforderlich. Nur ein hohes Maß an Interoperabilität, zu der sich alle Partner eines Ökosystems bekennen und gleichermaßen beitragen, gewährleistet die Vernetzung über Unternehmens- und Branchengrenzen hinweg. Dazu braucht es Standards und Integration, einen einheitlichen regulatorischen Rahmen sowie dezentrale Systeme.',
    },
    links: {
      en: [
        {
          text: 'Learn more in the policy paper on Interoperability',
          url: '',
        },
      ],
      de: [
        {
          text: 'Mehr dazu im Positionspapier Interoperabilität',
          url: '',
        },
      ],
    },
  },
  imageSmall: require('./assets/scenes/interoperability-small.svg'),
  imageBig: require('./assets/scenes/scene--empty.svg'),
  flag: 'left',
  pos: {
    x: 220,
    y: 300,
  },

  marks: [
    {
      handleNext: 'interoperability-standards-und-integration',
      x: 105,
      y: 65,
      type: 'standards',
      title: {
        en: `Standards<br/>and integration`,
        de: `Standards<br/>und Integration`,
      },
      text: {
        en: `<p>The outstanding global position when it comes to the <b>integration of individual solutions to
        become Industrie 4.0 systemic solutions</b> is largely rooted in the intensive and long-standing
        efforts to develop standards. This considerably facilitates integration and thus represents a
        basis for interoperability. This core competence needs to be used and developed further in
        accordance with the needs of digital ecosystems.</p><p>Not least due to cross-sectoral reference
        architectures and the establishment of an administration shell as a digital image of the real
        world, new approaches are now available and are being underpinned and developed to form
        a “USB standard for Industrie 4.0”.</p>`,
        de: `<p>Die weltweit hervorragende Positionierung in der <b>Integration von Einzel- zu
        Systemlösungen</b> von Industrie 4.0 basiert in wesentlichen Teilen auf intensiven und
        langjährigen Anstrengungen bei der Entwicklung von Standards. Dies erleichtert die
        Integration wesentlich und stellt daher eine Basis für Interoperabilität dar. Diese
        Kernkompetenz gilt es zu nutzen und entsprechend den Anforderungen digitaler
        Ökosysteme weiter zu entwickeln.</p><p>Nicht zuletzt durch branchenübergreifende
        Referenzarchitekturen und der Etablierung einer Verwaltungsschale als digitalem
        Abbild der realen Welt im Digitalen liegen neue Ansätze vor, deren weitere
        Untersetzung und Ausarbeitung nun konsequent in Richtung eines „USB-Standards
        für Industrie 4.0“ vorangetrieben wird.</p>`,
      },
    },
    {
      handleNext: 'interoperability-fegulatory-framework',
      x: 72,
      y: 5.5,
      type: 'regulation',
      title: {
        en: `Regulatory<br/>framework`,
        de: `Regulatorischer<br/>Rahmen`,
      },
      text: {
        en: `In order to ensure networking, exchange and cooperation in <b>open ecosystems with fair and
        equal conditions for all stakeholders</b>, a regulatory framework is required – at the national,
        European and also international level. This entails the anchoring of governance rules and the
        development of the innovation system, as well as the reflection of aspects of data autonomy
        and security, and the interests of employees and individuals in general. `,
        de: `Um Vernetzung, Austausch und Kooperation in <b>offenen Ökosystemen mit fairen und
        gleichen Bedingungen für alle Akteure</b> sicherzustellen, sind regulatorische
        Rahmenbedingungen erforderlich – im nationalen, europäischen und auch
        internationalen Maßstab. Dabei gilt es Governance-Regeln zu verankern sowie das
        Innovationssystem weiterzuentwickeln, aber auch Aspekte der Datensouveränität
        und -sicherheit ebenso abzubilden, wie Interessen der Beschäftigten und des
        Individuums allgemein. `,
      },
    },
    {
      handleNext: 'interoperability-aecentralised-systems-and-ai',
      x: 137.3,
      y: 37.5,
      type: 'ai',
      title: {
        en: `Decentralised systems<br/>and artificial intelligence`,
        de: `Dezentrale Systeme<br/>und Künstliche Intelligenz`,
      },
      text: {
        en: `<p>Decentralised, autonomous systems with embedded intelligence are of far greater
        significance in the digital ecosystems of industrial value creation (B2B) than in the B2C sector.
        The <b>cooperative and transparent use and interconnection of various types of machine and
        user data</b> in a well integrated ecosystem based on a standardised architecture permits the
        development of new solutions and business models through the use of artificial intelligence
        in a variety of ways.</p><p>When it comes to the beneficial use of AI at the various levels of
        industrial practice (edge, premises, cloud), a key role alongside <b>Big Data</b> is played by the
        collection and use of <b>Smart Data.</b></p>`,
        de: `<p>Dezentrale, autonome Systeme mit eingebetteter Intelligenz sind in den digitalen
        Ökosystemen der industriellen Wertschöpfung (B2B) von sehr viel größerer
        Bedeutung als im B2C-Bereich. Die <b>kooperative und transparente Nutzung und
        Verknüpfung von unterschiedlichsten Maschinen- und Nutzerdaten</b> in einem gut
        verzahnten Ökosystem mit standardisierter Architektur ermöglicht unter Einbezug
        verschiedener Ansätze der künstlichen Intelligenz die Entwicklung neuer
        Lösungsansätze und Geschäftsmodelle.</p><p>Für den nutzenbringenden Einsatz von KI auf
        den verschiedenen Ebenen der industriellen Praxis (Edge, Premises, Cloud) spielen
        neben <b>Big Data</b> vor allem die Gewinnung und Nutzung von <b>Smart Data</b> eine zentrale
        Rolle.</p>`,
      },
    },
  ],
  subscenes: [
    {
      name: 'Interoperability standards und integration',
      id: 'interoperability-standards-und-integration',
      type: 'subscene',
      title: {
        en: 'Standards and integration',
        de: 'Standards und Integration',
      },
      subtitle: {
        en: '',
        de: '',
      },

      information: {
        title: {
          en: 'Integration of individual solutions to Industrie 4.0 systemic solutions',
          de: 'Integration von Einzel- zu Systemlösungen in der Industrie 4.0',
        },
        text: {
          en:
            '"Standards enable integration and provide a basis for interoperability. This core competence and outstanding global position needs to be used and developed further in accordance with the needs of digital ecosystems. <br /> Due to cross-sectoral reference architectures and the establishment of an administration shell as a digital image of the real world, new approaches are now available and are being underpinned and developed to form a “USB standard for Industrie 4.0”. "',
          de:
            '"Standards ermöglichen Integration und stellen eine Basis für Interoperabilität dar. Diese Kernkompetenz und weltweit hervorragende Positionierung müssen für digitale Ökosysteme weiterentwickelt werden. <br />Durch branchenübergreifende Referenzarchitekturen und die Verwaltungsschale als digitales Abbild der realen Welt im Digitalen liegen neue Ansätze vor. Diese werden nun konsequent in Richtung eines „USB-Standards für Industrie 4.0“ ausgearbeitet."',
        },

        links: {
          // en: [
          //   {
          //     text: 'Norms and standards within PI4.0',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Navigation/EN/Industrie40/AreasofAction/NormsAndStandards/norms-and-standards.html',
          //   },
          //   {
          //     text: 'Making I4.0 components interoperable',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/2019-administration-shell-flyer.html',
          //   },
          //   {
          //     text: 'The Administration Shell in Practice',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/admin-shell-in-practice-flyer.html',
          //   },
          // ],
          // de: [
          //   {
          //     text: 'Normen & Standards in der PI4.0',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/DE/Newsletter/2019/Ausgabe17/2019-17-KI-Sicherheitsaspekte.html',
          //   },
          //   {
          //     text: 'Struktur der Verwaltungsschale ',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/kuenstliche-intelligenz-und-recht.html',
          //   },
          //   {
          //     text: 'Verwaltungsschale in der Praxis ',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/DE/Newsletter/2019/Ausgabe17/2019-17-KI-Recht-I4.0.html',
          //   },
          //   {
          //     text: 'Das Referenzarchitekturmodell Industrie 4.0 ',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/DE/Newsletter/2019/Ausgabe17/2019-17-KI-Recht-I4.0.html',
          //   },
          // ],
        },
      },
      marks: [
        {
          isNewMarker: true,
          x: 58,
          y: 70,
          type: 'theme',
          contentType: 'link',
          link:
            'https://www.plattform-i40.de/PI40/Redaktion/DE/Newsletter/2019/Ausgabe17/2019-17-KI-Sicherheitsaspekte.html',

          label: {
            en: 'Normen & Standards in der PI4.0',
            de: 'Normen & Standards in der PI4.0',
          },
        },
        {
          isNewMarker: true,
          x: 20,
          y: 0,
          type: 'groups',
          contentType: 'link',
          link: {
            de:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/kuenstliche-intelligenz-und-recht.html',
            en: 'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/AI-in-Industrie4.0.html',
          },
          label: {
            en: 'Norms and standards within PI4.0',
            de: 'Struktur der Verwaltungsschale',
          },
        },
        {
          isNewMarker: true,
          x: 60,
          y: 30,
          type: 'publication',
          contentType: 'link',
          link: {
            de:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/2019-verwaltungsschale-in-der-praxis.html',
            en: 'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/AI-in-Industrie4.0.html',
          },
          label: {
            en: 'Making I4.0 components interoperable',
            de: 'Verwaltungsschale in der Praxis',
          },
        },
        {
          isNewMarker: true,
          x: 20,
          y: 54,
          type: 'publication',
          contentType: 'link',
          link: {
            de: 'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/zvei-faktenblatt-rami.html',
            en:
              'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/admin-shell-in-practice-flyer.html',
          },
          label: {
            en: 'The Administration Shell in Practice',
            de: 'Das Referenzarchitekturmodell<br /> Industrie 4.0',
          },
        },
      ],
      pos: {
        x: 48,
        y: 35,
        zIndex: 0,
      },

      imageSmall: require('./assets/scenes/interoperability/2_2_1_IFOK_WIM_INTEROPERABILITY_STANDARDS_platform_for_svg_je.svg'),
      imageBig: require('./assets/scenes/interoperability/2_2_1_IFOK_WIM_INTEROPERABILITY_STANDARDS_platform_for_svg_je.svg'),
    },
    {
      name: 'Interoperability fegulatory framework',
      id: 'interoperability-fegulatory-framework',
      type: 'subscene',
      title: {
        en: 'Regulatory framework',
        de: 'Regulatorischer Rahmen',
      },
      subtitle: {
        en: '',
        de: '',
      },

      information: {
        title: {
          en: 'Regulatory framework for fair and open ecosystems',
          de: 'Regulatorischer Rahmen für faire und offene Ökosysteme',
        },
        text: {
          en:
            'In order to ensure networking, exchange and cooperation in open ecosystems with fair and equal conditions for all stakeholders, a regulatory framework is required – at the national, European and also international level. This entails the anchoring of governance rules and the development of the innovation system, as well as the reflection of aspects of data autonomy and security, and the interests of employees and individuals in general.',
          de:
            'Um Vernetzung, Austausch und Kooperation in offenen Ökosystemen mit fairen und gleichen Bedingungen für alle Akteure sicherzustellen, sind regulatorische Rahmenbedingungen erforderlich – im nationalen, europäischen und auch internationalen Maßstab. Dabei gilt es Governance-Regeln zu verankern und das Innovationssystem weiterzuentwickeln. Es müssen Aspekte der Datensouveränität und -sicherheit, sowie Interessen der Beschäftigten und des Individuums abgebildet werden.',
        },

        links: {
          // en: [
          //   {
          //     text: 'Legal framework for I4.0',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Navigation/EN/Industrie40/AreasofAction/LegalFramework/legal-framework.html',
          //   },
          //   {
          //     text: 'Blockchain and the Law in the Context of I4.0',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/blockchain-and-the-law-industrie4.0.html',
          //   },
          //   {
          //     text: 'Changes to competition law in the context of I4.0',
          //     url: 'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/competition-law-short.html',
          //   },
          // ],
          // de: [
          //   {
          //     text: 'Rechtliche Rahmenbedingungen in der PI4.0',
          //     url: 'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/sozialpartnerdialog.html',
          //   },
          //   {
          //     text: 'Künstliche Intelligenz und Recht im Kontext von I4.0',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/kuenstliche-intelligenz-und-recht.html',
          //   },
          //   {
          //     text: 'Blockchain und Recht im Kontext von Industrie 4.0 ',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/DE/Anwendungsbeispiele/410-dfki-ki-systeme/beitrag-dfki-ki-systeme.html',
          //   },
          // ],
        },
      },
      pos: {
        x: 15,
        y: 0,
        zIndex: 2,
      },
      marks: [
        {
          isNewMarker: true,
          x: 58,
          y: 70,
          type: 'theme',
          contentType: 'link',
          link: {
            de:
              'https://www.plattform-i40.de/PI40/Navigation/DE/Industrie40/Handlungsfelder/Rechtsrahmen/rechtsrahmen.html',
            en: 'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/AI-in-Industrie4.0.html',
          },

          label: {
            en: 'Legal framework for I4.0',
            de: 'Rechtliche Rahmenbedingungen <br />in der PI4.0',
          },
        },
        {
          isNewMarker: true,
          x: 20,
          y: 0,
          type: 'groups',
          contentType: 'link',
          link: {
            de:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/kuenstliche-intelligenz-und-recht.html',
            en: 'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/AI-in-Industrie4.0.html',
          },
          label: {
            en: 'Blockchain and the Law in the Context of I4.0',
            de: 'Künstliche Intelligenz und<br /> Recht im Kontext von I4.0',
          },
        },
        {
          isNewMarker: true,
          x: 60,
          y: 30,
          type: 'publication',
          contentType: 'link',
          link: {
            de:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/2019-verwaltungsschale-in-der-praxis.html',
            en: 'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/competition-law-short.html',
          },
          label: {
            en: 'Changes to competition<br /> law in the context of I4.0',
            de: 'Blockchain und Recht <br/>im Kontext von Industrie 4.0 ',
          },
        },
      ],
      imageSmall: require('./assets/scenes/interoperability/2_2_2_IFOK_WIM_INTEROPERABILITY_REGULATION_platform_for_svg_je.svg'),
      imageBig: require('./assets/scenes/interoperability/2_2_2_IFOK_WIM_INTEROPERABILITY_REGULATION_platform_for_svg_je.svg'),
    },
    {
      name: 'Interoperability aecentralised systems and ai',
      id: 'interoperability-aecentralised-systems-and-ai',
      type: 'subscene',
      title: {
        en: 'Decentralised systems and artificial intelligence',
        de: 'Dezentrale Systeme und Künstliche Intelligenz',
      },
      subtitle: {
        en: '',
        de: '',
      },
      information: {
        title: {
          en: 'Smart data usage through decentralized systems and artificial intelligence',
          de: 'Smarte Datennutzung durch dezentrale Systeme und Künstliche Intelligenz',
        },
        text: {
          en:
            'Decentralised, autonomous systems with embedded intelligence are crucial for the digital ecosystems of industrial value creation (B2B). In this way, the cooperative and transparent use and interconnection of various types of machine and user data permits the development of new solutions and business models. When it comes to the beneficial use of AI at the various levels of industrial practice (edge, premises, cloud), a key role alongside Big Data is played by the collection and use of Smart Data. ',
          de:
            'Dezentrale, autonome Systeme mit eingebetteter Intelligenz sind in den digitalen Ökosystemen der industriellen Wertschöpfung (B2B) essentiell. So ermöglicht die kooperative und transparente Nutzung und Verknüpfung von Maschinen- und Nutzerdaten die Entwicklung neuer Lösungsansätze und Geschäftsmodelle. Für den nutzenbringenden Einsatz von KI auf den verschiedenen Ebenen der industriellen Praxis (Edge, Premises, Cloud) spielt die Gewinnung und Nutzung von Smart Data eine zentrale Rolle.',
        },

        links: {
          // en: [
          //   {
          //     text: 'Technology Scenario: Artificial Intelligence in I4.0',
          //     url: 'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/AI-in-Industrie4.0.html',
          //   },
          // ],
          // de: [
          //   {
          //     text: 'Technologieszenario: Künstliche Intelligenz in der I4.0',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/DE/Anwendungsbeispiele/223-visualisierung-des-wertstroms-bosch/beitrag-visualisierung-des-wertstroms-bosch.html',
          //   },
          //   {
          //     text: 'Künstliche Intelligenz in Sicherheitsaspekten der I4.0',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/DE/Anwendungsbeispiele/223-visualisierung-des-wertstroms-bosch/beitrag-visualisierung-des-wertstroms-bosch.html',
          //   },
          //   {
          //     text: 'Künstliche Intelligenz und Recht im Kontext von I4.0',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/DE/Newsletter/2019/Ausgabe17/2019-17-KI-Recht-I4.0.html',
          //   },
          //   {
          //     text: 'Partnerschaft mit dem Wissenschaftsjahr zu KI ',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/DE/Anwendungsbeispiele/410-dfki-ki-systeme/beitrag-dfki-ki-systeme.html',
          //   },
          // ],
        },
      },
      marks: [
        {
          isNewMarker: true,
          x: 58,
          y: 70,
          type: 'publication',
          contentType: 'link',
          link: {
            en: 'https://www.plattform-i40.de/PI40/Redaktion/EN/Standardartikel/working-group-05.html',
            de:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Anwendungsbeispiele/223-visualisierung-des-wertstroms-bosch/beitrag-visualisierung-des-wertstroms-bosch.html',
          },

          label: {
            en: 'Technologieszenario: Künstliche <br />Intelligenz in der I4.0',
            de: 'Technology Scenario: Artificial<br /> Intelligence in I4.0',
          },
        },
        {
          isNewMarker: true,
          x: 20,
          y: 50,
          type: 'publication',
          contentType: 'link',
          link: {
            en:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Anwendungsbeispiele/223-visualisierung-des-wertstroms-bosch/beitrag-visualisierung-des-wertstroms-bosch.html',
            de:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Anwendungsbeispiele/223-visualisierung-des-wertstroms-bosch/beitrag-visualisierung-des-wertstroms-bosch.html',
          },
          label: {
            en: 'Künstliche Intelligenz in<br /> Sicherheitsaspekten der I4.0',
            de: 'Künstliche Intelligenz in<br /> Sicherheitsaspekten der I4.0',
          },
        },
        {
          isNewMarker: true,
          x: 60,
          y: 30,
          type: 'publication',
          contentType: 'link',
          link: {
            en:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/2019-verwaltungsschale-in-der-praxis.html',
            de:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/2019-verwaltungsschale-in-der-praxis.html',
          },
          label: {
            en: 'Künstliche Intelligenz und<br /> Recht im Kontext von I4.0',
            de: 'Künstliche Intelligenz und <br/>Recht im Kontext von I4.0',
          },
        },
        {
          isNewMarker: true,
          x: 0,
          y: 80,
          type: 'news',
          contentType: 'link',
          link: {
            en:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Newsletter/2019/Ausgabe17/2019-17-Partnerschaft-KI-Wissenschaftjahr.html',

            de:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Newsletter/2019/Ausgabe17/2019-17-Partnerschaft-KI-Wissenschaftjahr.html',
          },
          label: {
            en: 'Partnerschaft mit dem<br /> Wissenschaftsjahr zu KI',
            de: 'Partnerschaft mit dem<br /> Wissenschaftsjahr zu KI',
          },
        },
      ],
      pos: {
        x: 85.5,
        y: -2,
        zIndex: 0,
      },
      imageSmall: require('./assets/scenes/interoperability/2_2_3_IFOK_WIM_INTEROPERABILITY_AI_Platformfor_svg_je.svg'),
      imageBig: require('./assets/scenes/interoperability/2_2_3_IFOK_WIM_INTEROPERABILITY_AI_Platformfor_svg_je.svg'),
    },
  ],
};

const sustainability = {
  name: 'Sustainability',
  id: 'sustainability',
  type: 'scene',
  title: {
    en: 'Sustainability',
    de: 'Nachhaltigkeit',
  },
  subtitle: {
    en: 'Modern industrial value creation ensures high standard of living',
    de: 'Moderne industrielle Wertschöpfung sichert hohen Lebensstandard.',
  },
  information: {
    title: {
      en: '',
      de: '',
    },
    text: {
      en:
        'Economic, environmental and social sustainability is a fundamental pillar in our societal values. Firstly, these considerations feed into Industrie 4.0, and secondly, Industrie 4.0 promotes substantial progress on sustainability. Key aspects of sustainability in the ecosystems of the future are decent work and education, mitigating climate change, the circular economy and social inclusion. ',
      de:
        'Ökonomische, ökologische und soziale Nachhaltigkeit stellen einen fundamentalen Eckpfeiler der gesellschaftlichen Wertorientierung dar. Diese Aspekte fließen einerseits in Industrie 4.0 ein, andererseits unterstützt Industrie 4.0 die Umsetzung der Nachhaltigkeitsziele. Schlüsselaspekte von Nachhaltigkeit in den Ökosystemen der Zukunft sind gute Arbeit und Bildung, Klimaschutz und zirkuläre Wirtschaft sowie gesellschaftliche Teilhabe.',
    },

    links: {
      en: [
        {
          text: 'Learn more in the policy paper on  Sustainability',
          url: '',
        },
      ],
      de: [
        {
          text: 'Mehr dazu im Positionspapier Nachhaltigkeit',
          url: '',
        },
      ],
    },
  },
  imageSmall: require('./assets/scenes/sus.svg'),
  imageBig: require('./assets/scenes/scene--empty.svg'),
  flag: 'right',
  pos: {
    x: 1020,
    y: 350,
  },
  marks: [
    {
      handleNext: 'interoperability-decent-work-and-education',
      x: 58,
      y: 5.5,
      type: 'good-work',
      title: {
        en: 'Decent work<br/>and education',
        de: 'Gute Arbeit<br/>und Bildung',
      },
      text: {
        en: `<p>By placing the human being at the centre, Industrie 4.0 is making significant contributions
        towards a further improvement in working conditions. In view of our innovative equipment
        manufacturers and an internationally competitive user industry, <b>Industrie 4.0 is helping us to
        maintain a high level of employment</b>.</p><p>Multiplier and spill-over effects extend the impact to
        other sectors. The <b>outstanding level of education of the workforce</b> offers a stable basis for
        life-long learning, and the numerous further training opportunities offer needs-oriented
        possibilities to deliver this. This should be used and promoted proactively in order to respond
        to the ongoing skills shifts.</p>`,
        de: `<p>Mit dem Menschen im Zentrum leistet Industrie 4.0 im sozialpartnerschaftlichen
        Dialog signifikante Beträge zur weiteren Verbesserung der Arbeitsbedingungen. Mit
        einer innovativen Ausrüsterindustrie und einer international wettbewerbsfähigen
        Anwenderindustrie <b>trägt Industrie 4.0 zum Erhalt eines hohen
        Beschäftigungsniveaus bei</b>.</p><p>Multiplikations- und Spillover-Effekte strahlen auf andere
        Branchen aus. Das <b>hervorragende Bildungsniveau der Belegschaften</b> bietet eine
        stabile Basis für ein lebensbegleitendes Weiterlernen, für das die zahlreichen
        Weiterbildungsmöglichkeiten bedarfsgerechte Möglichkeiten bieten. Diese gilt es
        proaktiv zu nutzen und zu fördern, um den sich weiter verschiebenden
        Kompetenzbedarfen („Skill-Shift“) entsprechen zu können.</p>`,
      },
    },
    {
      handleNext: 'interoperability-social-participation',
      x: 125,
      y: 30,
      type: 'social',
      title: {
        en: 'Social<br/>participation',
        de: 'Gesellschaftliche<br/>Teilhabe',
      },
      text: {
        en: `Industrie 4.0 stands for a process of transformation which embraces the whole of society,
        entailing far-reaching changes for the stakeholders. The overarching goal is that the <b>
        industrial and social innovations generated by Industrie 4.0</b> should not only create
        challenges for these stakeholders, but also and in particular new opportunities. This process
        of societal change requires not only close cooperation at corporate level, but also
        participation and co-determination by all stakeholders: starting from a dialogue between the
        social partners in the individual enterprise to cross-company and cross-sectoral aspects of
        cooperation and issues embracing the whole of society in terms of the use of digital
        technologies and artificial intelligence in our day-to-day lives.`,
        de: `<p>Industrie 4.0 stellt einen gesamtgesellschaftlichen Transformationsprozess dar. Damit
        gehen weitreichende Veränderungen für die Beteiligten einher. Übergeordnetes Ziel
        ist, dass <b>Industrie 4.0 im Sinne einer industriellen und sozialen Innovation</b> diesen
        Beteiligten nicht nur Herausforderungen auferlegt, sondern vor allem neue Chancen
        eröffnet. Dieser gesellschaftliche Change-Prozess erfordert nicht nur enge
        Kooperationen auf Ebene der Unternehmen, sondern letztlich Beteiligung und
        Mitbestimmung aller Akteure: Angefangen vom sozialpartnerschaftlichen Dialog im
        einzelnen Betrieb, über unternehmens- und branchenübergreifende Aspekte der
        Zusammenarbeit bis hin zu gesamtgesellschaftlichen Fragestellungen in Bezug auf die
        Nutzung digitaler Technologie und Künstlicher Intelligenz in unserem Alltag.</p> `,
      },
    },
    {
      handleNext: 'interoperability-climate-change-mitigation',
      x: 105,
      y: 55,
      type: 'environment',
      title: {
        en: 'Climate change mitigation<br/>and the circular economy ',
        de: 'Klimaschutz und<br/>zirkuläre Wirtschaft',
      },
      text: {
        en: `Industrie 4.0 makes it possible to leverage additional potential for resource efficiency. A
        combination of design-based and process-based approaches can create closed material
        cycles throughout the entire product lifetime. Service-oriented business models make
        products the basis for services and thus keep them under the care and maintenance of the
        manufacturer, meaning that the latter can build a more sustainable design into its product.
        <b>This means that Industrie 4.0 is a key enabler for the circular economy, and for
        environmental protection and climate action in general.</b>`,
        de: `Industrie 4.0 ermöglicht es, zusätzliche Potenziale der Ressourceneffizienz zu heben.
        In Kombination mit konstruktiven und prozessualen Ansätzen können Stoffkreisläufe
        über den gesamten Produktlebenszyklus geschlossen werden. Mit serviceorientierten
        Geschäftsmodellen werden Produkte zum Träger von Services und verbleiben so
        unter Obhut und Wartung des Herstellers, der dadurch schon in der Konstruktion
        nachhaltigere Ansätze realisieren kann. <b>Industrie 4.0 ist so ein maßgeblicher
        Befähiger für Kreislaufwirtschaft sowie Umwelt- und Klimaschutz insgesamt.</b>`,
      },
    },
  ],
  subscenes: [
    {
      name: 'Interoperability decent work and education',
      id: 'interoperability-decent-work-and-education',
      type: 'subscene',
      title: {
        en: 'Decent work and education',
        de: 'Gute Arbeit und Bildung',
      },
      subtitle: {
        en: '',
        de: '',
      },
      information: {
        title: {
          en: 'Maintaining and increasing employment and education levels',
          de: 'Erhalt und Steigerung von Beschäftigungs- und Bildungsniveau',
        },
        text: {
          en:
            'By placing the human being at the centre, Industrie 4.0 is making significant contributions towards further improving working conditions. In view of our innovative equipment manufacturers and an internationally competitive user industry, Industrie 4.0 is helping us to maintain a high level of employment. The outstanding level of education of the workforce offers a stable basis for life-long learning, to respond to the ongoing skills shifts. ',
          de:
            'Mit dem Menschen im Zentrum leistet Industrie 4.0 signifikante Beträge zur weiteren Verbesserung der Arbeitsbedingungen. Mit einer innovativen und international wettbewerbsfähigen Ausrüster- und Anwenderindustrie trägt Industrie 4.0 zum Erhalt eines hohen Beschäftigungsniveaus bei. Das hervorragende Bildungsniveau der Belegschaften bietet eine stabile Basis für ein lebensbegleitendes Weiterlernen, um den verschiebenden Kompetenzbedarfen („Skill-Shift“) entsprechen zu können.',
        },
        links: {
          // en: [
          //   {
          //     text: 'Work, Education and Training',
          //     url: 'https://www.plattform-i40.de/PI40/Redaktion/EN/Standardartikel/working-groups-05.html',
          //   },
          //   {
          //     text: 'Shaping the Digital Transformation Within Companies ',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/digital-transformation-training.html',
          //   },
          //   {
          //     text: 'AI technology for human activity recognition',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/EN/Use-Cases/410-dfki-ki-systeme/article-dfki-ai-systems.html',
          //   },
          // ],
          // de: [
          //   {
          //     text: 'Arbeit, Aus- und Weiterbildung',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Navigation/DE/Plattform/Arbeitsgruppen/AG05/arbeit-aus-und-weiterbildung.html',
          //   },
          //   {
          //     text: 'Beitrag der Sozialpartner zu Arbeit und Bildung',
          //     url: 'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/sozialpartnerdialog.html',
          //   },
          //   {
          //     text: 'KI-basierte Anzüge für Sicherheit und Effizienz',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/DE/Anwendungsbeispiele/410-dfki-ki-systeme/beitrag-dfki-ki-systeme.html',
          //   },
          // ],
        },
      },
      marks: [
        {
          isNewMarker: true,
          x: 58,
          y: 70,
          type: 'groups',
          contentType: 'link',
          link: {
            en: 'https://www.plattform-i40.de/PI40/Redaktion/EN/Standardartikel/working-group-05.html',
            de:
              'https://www.plattform-i40.de/PI40/Navigation/DE/Plattform/Arbeitsgruppen/AG05/arbeit-aus-und-weiterbildung.html',
          },
          label: {
            en: 'Work, Education and Training',
            de: 'Arbeit, Aus- und Weiterbildung',
          },
        },
        {
          isNewMarker: true,
          x: 20,
          y: 0,
          type: 'publication',
          contentType: 'link',
          link: {
            de: 'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/sozialpartnerdialog.html',
            en:
              'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/digital-transformation-training.html',
          },
          label: {
            en: 'Shaping the Digital<br /> Transformation Within Companies',
            de: 'Beitrag der Sozialpartner<br /> zu Arbeit und Bildung',
          },
        },
        {
          isNewMarker: true,
          x: 60,
          y: 30,
          type: 'use_case',
          contentType: 'link',
          link: {
            en:
              'https://www.plattform-i40.de/PI40/Redaktion/EN/Use-Cases/410-dfki-ki-systeme/article-dfki-ai-systems.html',
            de:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Anwendungsbeispiele/410-dfki-ki-systeme/beitrag-dfki-ki-systeme.html',
          },
          label: {
            en: 'AI technology for <br />human activity recognition',
            de: 'KI-basierte Anzüge für<br /> Sicherheit und Effizienz',
          },
        },
      ],
      pos: {
        x: 11,
        y: 11,
        zIndex: 0,
      },
      imageSmall: require('./assets/scenes/sustainability/2_3_1_IFOK_WIM_STUSTAINABILITY_Godd_work_Platform_for_svg_je.svg'),
      imageBig: require('./assets/scenes/sustainability/2_3_1_IFOK_WIM_STUSTAINABILITY_Godd_work_Platform_for_svg_je.svg'),
    },
    {
      name: 'Interoperability social participation',
      id: 'interoperability-social-participation',
      type: 'subscene',
      title: {
        en: 'Social participation',
        de: 'Gesellschaftliche Teilhabe',
      },
      subtitle: {
        en: '',
        de: '',
      },

      information: {
        title: {
          en: 'Social participation through industrial and social innovation',
          de: 'Gesellschaftliche Teilhabe durch industrielle und soziale Innovation',
        },
        text: {
          en:
            'Industrie 4.0 stands for a process of transformation which embraces the whole of society. The overarching goal is to create new opportunities for all participants. This requires not only close cooperation at corporate level, but also participation and co-determination by all: starting from a dialogue between the social partners in the individual enterprise to cross-sectoral cooperation and issues embracing the whole of society in terms of the use of digital technologies in our day-to-day lives.',
          de:
            'Industrie 4.0 stellt einen gesamtgesellschaftlichen Transformationsprozess mit weitreichenden Veränderungen dar. Ziel ist, allen Beteiligten neue Chancen eröffnet. Das erfordert nicht nur enge Kooperationen auf Ebene der Unternehmen, sondern Beteiligung und Mitbestimmung Aller: Vom sozialpartnerschaftlichen Dialog im einzelnen Betrieb, über branchenübergreifende Zusammenarbeit hin zu Fragestellungen in Bezug auf die Nutzung digitaler Technologie in unserem Alltag. ',
        },
        links: {
          // en: [
          //   {
          //     text: 'Creating opportunities in the way work is organised',
          //     url: 'https://www.plattform-i40.de/PI40/Navigation/EN/Industrie40/AreasofAction/Work40/work-40.html',
          //   },
          //   {
          //     text: 'Visualization of the value stream',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/EN/Use-Cases/223-visualization-of-the-value-stream-bosch/article-visualization-of-the-value-stream-bosch.html',
          //   },
          // ],
          // de: [
          //   {
          //     text: 'Die sozialpartnerschaftlichen Dialoge der PI4.0',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/criteria-industrie-40-products.pdf?__blob=publicationFile&v=5',
          //   },
          //   {
          //     text: 'Gesteigerte Transparenz durch vernetzte Waren',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/DE/Anwendungsbeispiele/223-visualisierung-des-wertstroms-bosch/beitrag-visualisierung-des-wertstroms-bosch.html',
          //   },
          //   {
          //     text: 'Die digitale Transformation im Betrieb gestalten ',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/digitale-transformation-im-betrieb-aus-und-weiterbildung.html',
          //   },
          // ],
        },
      },
      marks: [
        {
          isNewMarker: true,
          x: 58,
          y: 70,
          type: 'publication',
          contentType: 'link',
          link: {
            de: 'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/sozialpartnerdialog.html',
            en: 'https://www.plattform-i40.de/PI40/Navigation/EN/Industrie40/AreasofAction/Work40/work-40.html',
          },
          label: {
            en: 'Creating opportunities in <br />the way work is organised',
            de: 'Die sozialpartnerschaftlichen<br /> Dialoge der PI4.0',
          },
        },
        {
          isNewMarker: true,
          x: 20,
          y: 0,
          type: 'publication',
          contentType: 'link',
          link: {
            de: 'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/sozialpartnerdialog.html',
            en:
              'https://www.plattform-i40.de/PI40/Redaktion/EN/Use-Cases/223-visualization-of-the-value-stream-bosch/article-visualization-of-the-value-stream-bosch.html',
          },
          label: {
            en: 'Visualization of the value stream ',
            de: 'Gesteigerte Transparenz<br/> durch vernetzte Waren',
          },
        },
        {
          isNewMarker: true,
          x: 60,
          y: 30,
          type: 'publication',
          contentType: 'link',
          link: {
            en:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/digitale-transformation-im-betrieb-aus-und-weiterbildung.html',
            de:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Downloads/Publikation/digitale-transformation-im-betrieb-aus-und-weiterbildung.html',
          },
          label: {
            en: 'Die digitale Transformation<br /> im Betrieb gestalten ',
            de: 'Die digitale Transformation<br /> im Betrieb gestalten ',
          },
        },
      ],
      pos: {
        x: 70,
        y: 15,
        zIndex: 0,
      },
      imageSmall: require('./assets/scenes/sustainability/2_3_2_IFOK_WIM_STUSTAINABILITY_Society_platform_for_svg_je.svg'),
      imageBig: require('./assets/scenes/sustainability/2_3_2_IFOK_WIM_STUSTAINABILITY_Society_platform_for_svg_je.svg'),
    },
    {
      name: 'Interoperability climate change mitigation',
      id: 'interoperability-climate-change-mitigation',
      type: 'subscene',
      title: {
        en: 'Climate change mitigation ',
        de: 'Klimaschutz',
      },
      subtitle: {
        en: '',
        de: '',
      },
      information: {
        title: {
          en: 'Industrie 4.0 as an Enabler of Circular Economy and Climate Change Mitigation ',
          de: 'Industrie 4.0 als Befähiger von Kreislaufwirtschaft und Klimaschutz',
        },
        text: {
          en:
            'Industrie 4.0 makes it possible to leverage additional potential for resource efficiency. A combination of design-based and process-based approaches can create closed material cycles throughout the entire product lifetime. Service-oriented business models make products the basis for services and thus keep them under the care and maintenance of the manufacturer, meaning that the latter can build a more sustainable design into its product. ',
          de:
            'Industrie 4.0 ermöglicht es, zusätzliche Potenziale der Ressourceneffizienz zu heben. In Kombination mit konstruktiven und prozessualen Ansätzen können Stoffkreisläufe über den gesamten Produktlebenszyklus geschlossen werden. Mit serviceorientierten Geschäftsmodellen werden Produkte zum Träger von Services und verbleiben so unter Obhut und Wartung des Herstellers, der dadurch schon in der Konstruktion nachhaltigere Ansätze realisieren kann.',
        },
        links: {
          // en: [
          //   {
          //     text: 'Which criteria do I4.0 products need to fulfil?',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/criteria-industrie-40-products.html',
          //   },
          //   {
          //     text: 'Energy-Efficiency-Moduel (E2M)',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/criteria-industrie-40-products.html',
          //   },
          //   {
          //     text: 'EU FUTURING Circular Economy Project',
          //     url: 'http://www.futuring-project.eu/the-project',
          //   },
          // ],
          // de: [
          //   {
          //     text: 'Energietransparenz-System für intelligenten Steuerung',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/DE/Anwendungsbeispiele/037-energietransparenzsysteme-festo/beitrag-energietransparenzsysteme-festo.html',
          //   },
          //   {
          //     text: 'Kriterien für I4.0 Produkte mit Energie-Effizienz-Modul ',
          //     url:
          //       'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/criteria-industrie-40-products.pdf?__blob=publicationFile&v=5',
          //   },
          //   {
          //     text: 'FUTURING Projekt zu Kreislaufwirtschaft in der EU ',
          //     url: 'http://www.futuring-project.eu/the-project',
          //   },
          //   {
          //     text: 'Circular Economy Initiative',
          //     url: 'https://www.acatech.de/Projekt/circular-economy-initiative-deutschland/',
          //   },
          //   {
          //     text: 'Ressourceneffizienz- und Kreislaufwirtschaftskongress',
          //     url:
          //       'http://../Papiere%20Leitbild/Positionspapier%20Nachhaltigkeit/Ressourceneffizienz-%20und%20Kreislaufwirtschaftskongress%20Baden-W%C3%BCrttemberg%20(https:/www.ressourceneffizienzkongress.de)',
          //   },
          // ],
        },
      },

      marks: [
        {
          isNewMarker: true,
          x: 58,
          y: 70,
          type: 'use_case',
          contentType: 'link',
          link: {
            en:
              'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/criteria-industrie-40-products.html',
            de:
              'https://www.plattform-i40.de/PI40/Redaktion/DE/Anwendungsbeispiele/037-energietransparenzsysteme-festo/beitrag-energietransparenzsysteme-festo.html',
          },
          label: {
            en: 'Which criteria do I4.0 <br />products need to fulfil? ',
            de: 'Energietransparenz-System für<br /> intelligenten Steuerung',
          },
        },
        {
          isNewMarker: true,
          x: 20,
          y: 0,
          type: 'publication',
          contentType: 'link',
          link: {
            en:
              'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/criteria-industrie-40-products.html',
            de:
              'https://www.plattform-i40.de/PI40/Redaktion/EN/Downloads/Publikation/criteria-industrie-40-products.pdf?__blob=publicationFile&v=5',
          },
          label: {
            de: 'Kriterien für I4.0 Produkte<br /> mit Energie-Effizienz-Modul ',
            en: 'Energy-Efficiency-Moduel (E2M)',
          },
        },
        {
          isNewMarker: true,
          x: 60,
          y: 30,
          type: 'news',
          contentType: 'link',
          link: {
            de: 'http://www.futuring-project.eu/the-project',
            en: 'http://www.futuring-project.eu/the-project',
          },
          label: {
            en: 'EU FUTURING Circular Economy Project',
            de: 'FUTURING Projekt zu<br /> Kreislaufwirtschaft in der EU',
          },
        },
        // {
        //   isNewMarker: true,
        //   x: 120,
        //   y: 10,
        //   type: 'news',
        //   contentType: 'link',
        //   link: {
        //     de: 'https://www.acatech.de/Projekt/circular-economy-initiative-deutschland/',
        //     en: 'https://www.acatech.de/Projekt/circular-economy-initiative-deutschland',
        //   },
        //   label: {
        //     en: 'Circular Economy Initiative ',
        //     de: 'Circular Economy Initiative ',
        //   },
        // },
        {
          isNewMarker: true,
          x: 0,
          y: 90,
          type: 'news',
          contentType: 'link',
          link: {
            de:
              'http://../Papiere%20Leitbild/Positionspapier%20Nachhaltigkeit/Ressourceneffizienz-%20und%20Kreislaufwirtschaftskongress%20Baden-W%C3%BCrttemberg%20(https:/www.ressourceneffizienzkongress.de)',
            en:
              'http://../Papiere%20Leitbild/Positionspapier%20Nachhaltigkeit/Ressourceneffizienz-%20und%20Kreislaufwirtschaftskongress%20Baden-W%C3%BCrttemberg%20(https:/www.ressourceneffizienzkongress.de)',
          },
          label: {
            en: 'Ressourceneffizienz- und<br/>Kreislaufwirtschaftskongress ',
            de: 'Ressourceneffizienz- und<br/>Kreislaufwirtschaftskongress ',
          },
        },
      ],
      pos: {
        x: 40,
        y: 30,
        zIndex: 1,
      },
      imageSmall: require('./assets/scenes/sustainability/2_3_3_IFOK_WIM_STUSTAINABILITY_Enviroment_Plattform_for_svg_je.svg'),
      imageBig: require('./assets/scenes/sustainability/2_3_3_IFOK_WIM_STUSTAINABILITY_Enviroment_Plattform_for_svg_je.svg'),
    },
  ],
};

export default [ home, souverenty, interoperability, sustainability ];
